import React, { useState, useEffect } from "react";
import { Typography } from "@material-tailwind/react";
import { API_URL, get } from "lib/network/api";
import { useSelector } from "react-redux";
import NavTable from "./navTable";
import ModalDetails from "./modalDetails";
import ModalInfo from "./modalInfo";
import ModalOffer from "./modalOffer";
import moment from "moment";
import CurrencyFormatter from "lib/CurrencyFormatter";
import toast from "react-hot-toast";
import findNameData from "lib/FindNameMasterData";
import TableHandle from "./tableHandle";

const TableOffers = () => {
  const [open, setOpen] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);
  const [openOffer, setopenOffer] = useState(false);
  const masterData = useSelector((state) => state.MasterData.data);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(null);
  const [perPage, setPerPage] = useState(10);
  const [detailId, setDetailId] = useState(null);

  const FetchApplication = () => {
    setLoading(true);
    get(
      `${API_URL}ldr/loan/applications-pending?page=${page}&page_size=${perPage}`
    )
      .then((res) => {
        setData(res.data);
        setLastPage(res.metadata.last_page ? res.metadata.last_page : 1);
        setPage(res.metadata.current_page ? res.metadata.current_page : 1);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch((err) => {
        toast.error("Something Went Wrong");
        setLoading(false);
      });
  };

  useEffect(() => {
    FetchApplication();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, perPage]);

  const formattedDate = (dateString) => {
    return moment(dateString).format("MMM DD, YYYY");
  };

  const handlePrevPage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (page !== lastPage) {
      setPage(page + 1);
    }
  };

  const openDetail = (paramsId) => {
    setOpen(true);
    setDetailId(paramsId);
  };

  // const openInfoModal = (paramsId) => {
  //   setOpenInfo(true);
  //   setDetailId(paramsId);
  // };

  const openOfferModal = (paramsId) => {
    setopenOffer(true);
    setDetailId(paramsId);
  };

  return (
    <div className="flow-root">
      <div>
        <div className="shadow ring-1 ring-black ring-opacity-5 rounded-t-lg overflow-hidden">
          <div className="py-4 px-6 bg-white border-b border-gray-200 flex flex-col">
            <span className="font-semibold text-sm">Loan Application</span>
            {/* <span className="text-sm text-gray-500">
              Tip: Click on 1 of the rows
            </span> */}
          </div>
          <div className="overflow-x-auto costume-scrollbar">
            <div className="inline-block min-w-full align-middle">
              <div className="overflow-hidden ">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        className="py-3.5 pl-4 pr-3 text-left text-xs font-semibold text-gray-900 sm:pl-6"
                      >
                        Date
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900"
                      >
                        Loan Purpose
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900"
                      >
                        Date of Birth
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900"
                      >
                        Gender
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900"
                      >
                        Job Title
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900"
                      >
                        Loan Amount
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900"
                      >
                        Tenor Duration
                      </th>
                      {/* <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900"
                      >
                        A.F %
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900"
                      >
                        M.I
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900"
                      >
                        M.R
                      </th> */}
                      <th
                        scope="col"
                        className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                      ></th>
                    </tr>
                  </thead>
                  <TableHandle
                    loading={loading}
                    loadingComponent={
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {[...Array(10)].map((item, idx) => {
                          return (
                            <tr key={idx}>
                              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-6">
                                <Typography
                                  key={idx}
                                  as="div"
                                  variant="h1"
                                  className="h-[15px] rounded-sm  bg-gray-300"
                                >
                                  &nbsp;
                                </Typography>
                              </td>
                              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-6">
                                <Typography
                                  key={idx}
                                  as="div"
                                  variant="h1"
                                  className="h-[15px] rounded-sm  bg-gray-300"
                                >
                                  &nbsp;
                                </Typography>
                              </td>
                              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-6">
                                <Typography
                                  key={idx}
                                  as="div"
                                  variant="h1"
                                  className="h-[15px] rounded-sm  bg-gray-300"
                                >
                                  &nbsp;
                                </Typography>
                              </td>
                              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-6">
                                <Typography
                                  key={idx}
                                  as="div"
                                  variant="h1"
                                  className="h-[15px] rounded-sm  bg-gray-300"
                                >
                                  &nbsp;
                                </Typography>
                              </td>
                              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-6">
                                <Typography
                                  key={idx}
                                  as="div"
                                  variant="h1"
                                  className="h-[15px] rounded-sm  bg-gray-300"
                                >
                                  &nbsp;
                                </Typography>
                              </td>
                              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-6">
                                <Typography
                                  key={idx}
                                  as="div"
                                  variant="h1"
                                  className="h-[15px] rounded-sm  bg-gray-300"
                                >
                                  &nbsp;
                                </Typography>
                              </td>
                              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-6">
                                <Typography
                                  key={idx}
                                  as="div"
                                  variant="h1"
                                  className="h-[15px] rounded-sm  bg-gray-300"
                                >
                                  &nbsp;
                                </Typography>
                              </td>
                              <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-xs font-semibold max-w-32">
                                <Typography
                                  key={idx}
                                  as="div"
                                  variant="h1"
                                  className="h-[15px] rounded-sm  bg-gray-300"
                                >
                                  &nbsp;
                                </Typography>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    }
                    data={data}
                    dataComponent={
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {data.map((item, idx) => (
                          <tr key={idx}>
                            <td className="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-6">
                              {item.created_at
                                ? formattedDate(item.created_at)
                                : "-"}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900">
                              {item?.main_purpose_id
                                ? `${findNameData(
                                    masterData,
                                    "purposes",
                                    item?.main_purpose_id
                                  )}`
                                : "-"}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900">
                              {item.date_of_birth
                                ? moment(item.date_of_birth).format(
                                    "DD/MM/YYYY"
                                  )
                                : "-"}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900">
                              {item?.user.gender ? item?.user.gender : "-"}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900">
                              {item?.job_title_id
                                ? `${findNameData(
                                    masterData,
                                    "job-titles",
                                    item?.job_title_id
                                  )}`
                                : "-"}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900">
                              {item.loan_amount
                                ? CurrencyFormatter("en-SG", "SGD", 0).format(
                                    item.loan_amount
                                  )
                                : "-"}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900">
                              {item?.tenor_id
                                ? `${findNameData(
                                    masterData,
                                    "tenor",
                                    item?.tenor_id
                                  )} months`
                                : "-"}
                            </td>
                            {/* <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900">
                          {item.af}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900">
                          {item.mi}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900">
                          {item.mr}
                        </td> */}
                            <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-xs font-semibold">
                              <div className="gap-x-2 flex flex-row justify-end">
                                <span
                                  onClick={() => openDetail(item.id)}
                                  className="text-primary hover:text-secondary cursor-pointer"
                                >
                                  Detail
                                </span>
                                {/* <span
                                  onClick={() => openInfoModal(item.id)}
                                  className="text-primary hover:text-secondary cursor-pointer"
                                >
                                  Info
                                </span>
                                <span className="text-primary hover:text-secondary cursor-pointer">
                              Docs
                            </span> */}
                                <span
                                  onClick={() => openOfferModal(item.id)}
                                  className="text-primary hover:text-secondary cursor-pointer"
                                >
                                  Make Offer
                                </span>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    }
                    colspan="7"
                  />
                </table>
              </div>
            </div>
          </div>
        </div>
        <NavTable
          prev={handlePrevPage}
          next={handleNextPage}
          disabledPrev={page === 1}
          disabledNext={page === lastPage}
          changePerPage={setPerPage}
          data={data}
        />
      </div>
      <ModalDetails
        open={open}
        setOpen={setOpen}
        id={detailId}
        masterData={masterData}
      />
      <ModalInfo
        open={openInfo}
        setOpen={setOpenInfo}
        id={detailId}
        masterData={masterData}
      />
      <ModalOffer
        open={openOffer}
        setOpen={setopenOffer}
        id={detailId}
        masterData={masterData}
      />
    </div>
  );
};

export default TableOffers;
